export default __webpack_public_path__ + "d0bf14ba22f3ce393720a10107a3d29a.svg";